<!-- <div class="body ui container" fxLayout="column"> -->
<div fxLayout="row" fxLayoutAlign="space-between center" class="top">
  <div
    fxLayoutAlign="start center"
    fxLayout="row"
    fxLayoutGap="20px"
    class="link"
  >
    <!-- <div >
                    <img src="assets/icons/left-arrow-icon.svg" alt="">
                </div> -->
    <div class="equipment-id">
      <!-- Title -->
      <h2 class="ui primary header">Application Notification</h2>
    </div>
  </div>
</div>

<div class="ui divider" appMargin marginY="3"></div>
<div *ngIf="success || error" tamsyMargin marginY="10px">
  <esl-message-toast [(message)]="error"></esl-message-toast>
  <esl-message-toast
    [(message)]="success"
    [messageType]="'success'"
  ></esl-message-toast>
</div>

<div class="ui basic segment" appMargin marginT="0">
  <sui-accordion class="styled fluid">
    <ng-template ngFor let-app [ngForOf]="apps">
      <sui-accordion-panel>
        <div title>
          <i class="dropdown icon"></i>
          <span class="test-name"> {{ app?.applicationName }}</span>
        </div>
        <div content class="bg" appPadding="0">
          <app-notification-config
            [user]="user"
            [app]="app"
          ></app-notification-config>
        </div>
      </sui-accordion-panel>
    </ng-template>
  </sui-accordion>
</div>
<!-- </div> -->
